import { createAppStore } from './create-store'

// The single store for this browser tab. Kept apart from `index.ts` so importing store helpers (selectors,
// `commit`, hooks) never opens a BroadcastChannel; only the app root and tests that want the real thing import this.
const created = createAppStore()

export const store = created.store
export const syncContext = created.ctx
